import { useContext } from "react"
import { object, string } from "prop-types"
import { Button, StackView } from "@planningcenter/tapestry-react"
import RegisterableContext from "components/admin/registerable/context"
import { api } from "utils/api"
import RegistrationButton from "../LegacyRegistration/RegistrationButton"

const Actions = ({ restoreAlertText = null, paths = {} }) => {
  const { registerable } = useContext(RegisterableContext)

  const handleCancel = () => {
    return alertModal(
      {
        title: "Cancel Registration?",
        text: "Any payments will not be automatically refunded.",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "No, don't cancel it",
        confirmButtonText: "Yes, cancel it!",
        customClass: "destructive-warning",
        closeOnConfirm: true
      },
      () => {
        api.post(paths.cancel).then(_resp => {
          alertModal(
            {
              title: "Canceled!",
              text: "Registration has been canceled.",
              type: "success",
              confirmButtonText: "Ok",
              closeOnConfirm: true
            },
            () => Turbolinks.visit()
          )
        })
      }
    )
  }

  const handleRestore = () => {
    return alertModal(
      {
        title: "Restore Registration?",
        text: restoreAlertText,
        showCancelButton: true,
        cancelButtonText: "No, don't restore it",
        confirmButtonText: "Yes, restore it!",
        closeOnConfirm: true,
        type: "warning"
      },
      () => {
        api.del(paths.cancel).then(_resp => {
          alertModal(
            {
              title: "Restored!",
              text: "Registration has been restored.",
              type: "success",
              confirmButtonText: "Ok",
              closeOnConfirm: true
            },
            () => Turbolinks.visit()
          )
        })
      }
    )
  }

  const handleDelete = () => {
    return alertModal(
      {
        title: "Delete Registration?",
        text: "This cannot be undone.",
        customClass: "destructive-warning",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "No, don't delete it",
        confirmButtonText: "Yes, delete it!",
        closeOnConfirm: true
      },
      () => {
        api.del(paths.show).then(_resp => {
          alertModal(
            {
              confirmButtonText: "Ok",
              type: "success",
              title: "Success",
              text: "Registration deleted successfully.",
              closeOnConfirm: true
            },
            () => Turbolinks.visit(paths.eventShow)
          )
        })
      }
    )
  }

  return (
    <StackView axis="horizontal" distribution="flex-end" spacing={1}>
      {registerable.totalCostMinusDiscounts && (
        <RegistrationButton modalUrl={paths.newDiscount}>Apply discount</RegistrationButton>
      )}
      {registerable.isDeletable && (
        <Button onClick={handleDelete} variant="outline" title="Delete registration" size="sm" />
      )}
      {registerable.isCanceled && (
        <Button onClick={handleRestore} variant="outline" title="Restore registration" size="sm" />
      )}
      {!registerable.isCanceled && (
        <Button onClick={handleCancel} variant="outline" title="Cancel registration" size="sm" />
      )}
    </StackView>
  )
}

Actions.propTypes = {
  restoreAlertText: string,
  paths: object
}

export default Actions
